import { defineComponent } from 'vue'
import * as fingerprint from './../../../../fingerprint';

export default defineComponent({
    name: "quick-registration",
    template: "#quick-registration",
    data: function () {
        return {
            email: '',
            password: '',
            showModal: false,
            generalError: '',
            relativeUrl: '',
            errors: {
                email: false,
                password: false,
                generalError: false
            }
        }
    },
    watch: {
        showModal(newValue) {
            console.log('showModal changed:', newValue);
        }
    },
    methods: {
        show() {
            this.generalError = null;
            this.showModal = true;
            this.$refs.component.style.display = "block";
        },
        hide() {
            this.showModal = false;
            this.$refs.component.style.display = "none";
        },
        validateEmail(): Boolean {
            this.errors.email = this.email == null || this.email.trim() == "";
            return !this.errors.email;
        },
        validatePassword() {
            this.errors.password = this.password == null || this.password.trim() == "";
            return !this.errors.password;
        },
        async submitQuickRegistrationForm(event: Event) {
            this.validateEmail()
            this.validatePassword();

            if (this.errors.email || this.errors.password) {
                event.preventDefault();
                return;
            }


            const formEl = document.getElementById('login-nav') as HTMLFormElement;
            var form = new FormData(formEl);
            form.append('fingerprint', fingerprint.getFingerprint());

            var requestVerificationToken = document.getElementsByName('__RequestVerificationToken')[0];

            if (requestVerificationToken != null)
                form.append('__RequestVerificationToken', (requestVerificationToken as any).value);

            await fetch(formEl.action, {
                method: formEl.method,
                body: form,
            }).then((response: Response) => {
                return response.json();
            }).then((response) => {
                if (response.errors != null) {
                    this.generalError = response.errors;
                }
                else if (response.success == true) {
                    if (response.redirect != null) {
                        window.location.href = response.redirect;
                    } else {
                        (window as any).location.reload();
                    }
                }
                return response;
            })
                .catch((error) => console.log(error));
        }
    }
});